export const AI_INPUT_ALL_FIELDS = '__all_fields__';

const uniqueTruthyStrings = (values) => {
  const seen = new Set();
  return (Array.isArray(values) ? values : [])
    .filter(value => typeof value === 'string')
    .map(value => value.trim())
    .filter(value => {
      if (!value || seen.has(value)) return false;
      seen.add(value);
      return true;
    });
};

export const getAiActionSourceFields = (action = {}) => {
  const fields = uniqueTruthyStrings(action.source_fields);
  const normalized = fields.length > 0
    ? fields
    : uniqueTruthyStrings([action.source_field]);
  if (normalized.includes(AI_INPUT_ALL_FIELDS)) {
    return [AI_INPUT_ALL_FIELDS];
  }
  return normalized;
};

export const changeAiActionSourceFields = (
  currentFields = [],
  nextFields = []
) => {
  const current = uniqueTruthyStrings(currentFields);
  const next = uniqueTruthyStrings(nextFields);
  const hadAll = current.includes(AI_INPUT_ALL_FIELDS);
  const hasAll = next.includes(AI_INPUT_ALL_FIELDS);

  if (hasAll && !hadAll) return [AI_INPUT_ALL_FIELDS];
  if (hasAll && hadAll) {
    return next.filter(value => value !== AI_INPUT_ALL_FIELDS);
  }
  return next;
};

export const normalizeActionForEditing = (action = {}) => ({
  ...action,
  source_fields: getAiActionSourceFields(action)
});

export const normalizeActionForEdit = (
  action = {},
  defaultAction = {}
) => {
  const isAiAction = (
    action.type === 'ai_set_field'
    || (
      action.type === 'add_comment'
      && action.comment_type === 'ai'
    )
  );
  const normalizedAction = isAiAction
    ? normalizeActionForEditing(action)
    : action;

  return {
    ...defaultAction,
    ...normalizedAction,
    target: Array.isArray(normalizedAction.target)
      ? normalizedAction.target.join(',')
      : (normalizedAction.target || ''),
    persons: Array.isArray(normalizedAction.persons)
      ? normalizedAction.persons.join(',')
      : (normalizedAction.persons || '')
  };
};

export const isAiActionComplete = (action = {}) => {
  const baseComplete = Boolean(
    getAiActionSourceFields(action).length > 0
    && action.ai_provider
    && String(action.ai_prompt || '').trim()
  );
  if (action.type === 'ai_set_field') {
    return Boolean(baseComplete && action.field);
  }
  return baseComplete;
};

export const sanitizeAiAction = (action = {}) => {
  const {
    source_field: legacySourceField,
    source_fields: rawSourceFields,
    ...rest
  } = action;
  return {
    ...rest,
    source_fields: getAiActionSourceFields({
      source_field: legacySourceField,
      source_fields: rawSourceFields
    })
  };
};
